import { combineReducers } from "redux";
import { reducer as FormReducer } from "redux-form";
import { reducer as toastrReducer } from "react-redux-toastr";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import testReducer from "../../components/ExperimentPage/testReducer";
import modalsReducer from "../../features/modals/modalReducer";
import authReducer from "../../features/auth/authReducer";
import asyncReducer from "../../features/async/asyncReducer";
import testPageReducer from "../../components/TestPage/testPageReducer";
import selectReducer from "../../features/selections/selectReducer";
import userDetailReducer from "../../components/UserDetail/UserDetailReducer";
import userTestTreeReducer from "../../features/userTestTree/userTestTreeReducer";

const rootReducer = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    form: FormReducer,
    test: testReducer,
    modals: modalsReducer,
    auth: authReducer,
    async: asyncReducer,
    testQ: testPageReducer,
    toastr: toastrReducer,
    selection: selectReducer,
    userDetail: userDetailReducer,
    userTestTreeReducer: userTestTreeReducer
});

export default rootReducer;
